<script>
    import FormTableBaseElement from "./FormTableBaseElement";

    export default {
        name: "FormTableBaseTextarea",
        extends: FormTableBaseElement,
        data() {
            return {
                innerModel: "",
            };
        },
        watch: {
            model() {
                this.innerModel = this.model;
            }
        },
        mounted() {
            this.innerModel = this.model || "";
        },
        methods: {
        },
    }
</script>